export default __webpack_public_path__ + "static/media/LUX_SALUDA.b3b5b539.png";